import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    copyClipboard: 'Copy to clipboard',
    ctaContinue: {
      mandatee: 'Add the updated draft statutes',
      nonMandatee: 'Add my updated draft statutes',
    },
    description: 'The document must be composed of the following elements:',
    elementsList: [
      'Completed draft statutes',
      'The list of subscribers attached to your draft statutes (this document must specify the amount of each contribution and the number of shares of each partner).',
    ],
    intro: {
      mandatee:
        'Please check or add the following mentions in the draft statutes:',
      nonMandatee:
        'Please check or add the following mentions in your draft statutes:',
    },
    mentionAppendix:
      'Copy and paste in the appendix “Etat des actes accomplis au nom de la société en formation avant la signature des statuts” (if the appendix is present)',
    mentionApports: 'Copy and paste in the “Apports” section',
    textCopied: 'Mention copied!',
    title: {
      mandatee: 'Verify the company’s draft statutes',
      nonMandatee: 'Verify your company’s draft statutes',
    },
  },
  fr: {
    checkDocument: {
      mandatee:
        'Veuillez vérifier ou ajouter les mentions suivantes dans le projet de statuts\u00A0:',
      nonMandatee:
        'Veuillez vérifier ou ajouter les mentions suivantes dans votre projet de statuts\u00A0:',
    },
    copyClipboard: 'Copier le texte',
    ctaContinue: {
      mandatee: 'Ajouter le projet de statuts à jour',
      nonMandatee: 'Ajouter mon projet de statuts à jour',
    },
    description: 'Le document doit être constitué des éléments suivants\u00A0:',
    elementsList: [
      'Le projet de statuts complet',
      'La liste des souscripteurs liée à votre projet de statuts (ce document doit préciser le montant de chaque apport et le nombre d’action de chaque associé·e).',
    ],
    intro: {
      mandatee:
        'Veuillez vérifier ou ajouter les mentions suivantes dans le projet de statuts\u00A0:',
      nonMandatee:
        'Veuillez vérifier ou ajouter les mentions suivantes dans votre projet de statuts\u00A0:',
    },

    mentionAppendix:
      'Copiez-collez dans l’annexe “Etat des actes accomplis au nom de la société en formation avant la signature des statuts” (si l’annexe est présente)',
    mentionApports: 'Copiez-collez dans la section “Apports”',
    textCopied: 'Mention copiée\u00A0!',
    title: {
      mandatee: 'Vérifiez le projet de statuts',
      nonMandatee: 'Vérifiez votre projet de statuts',
    },
  },
} as const);
